export const DETAIL_TRANSACTION = 'DETAIL_TRANSACTION'
export const DETAIL_ORDER_TRANSACTION = 'DETAIL_ORDER_TRANSACTION'
export const LIST_TRANSACTION = 'LIST_TRANSACTION'
export const DAILY_TRANSACTION = 'DAILY_TRANSACTION'
export const DAILY_CHECK_TRANSACTION = 'DAILY_CHECK_TRANSACTION'
export const DAILY_TRANSACTION_SUMMARY_BY_DATE = 'DAILY_TRANSACTION_SUMMARY_BY_DATE'
export const DAILY_TRANSACTION_LIST_BY_DATE = 'DAILY_TRANSACTION_LIST_BY_DATE'
export const TRANSACTION_TO_TRANSACTION_TABLE = 'TRANSACTION_TO_TRANSACTION_TABLE'
export const TRANSACTION_TO_TRANSACTION_SUMMARY = 'TRANSACTION_TO_TRANSACTION_SUMMARY'
